module.exports = __webpack_public_path__ + "img/location-setting-android.fb37c8ae.png";